import Vue from 'vue';

import Pui9Login from '@Pui9Login';
import { Pui9LoginCheckerMixin } from '@Pui9Login';
import Pui9Menu from '@Pui9Menu';
import Pui9Notify from '@Pui9Notifications';
import Pui9HttpRequests from '@Pui9Requests';
import Pui9Datatables from '@Pui9Datatables';
import Pui9Components from '@Pui9Components';
import Pui9Base from '@Pui9Base';
import Pui9Admin from '@Pui9Admin';


import store from './store/store';
import router from './router/router';
import i18n from './i18n/i18n';
import vuetify from './plugins/vuetify';
import puiEventsBus from './bus';
import beforeRun from './beforeRun';

import App from './App.vue';

import '@prodevelop-public/fontawesome-pro/css/all.css';
import '@Pui9Styles/pui9.css';

if (process.env.VUE_APP_PUI9_DEVELOPMENT == 'false') {
	require('@Pui9Components/dist/pui9-components.css');
	require('@Pui9Datatables/dist/pui9-datatables.css');
	require('@Pui9Login/dist/pui9-login.css');
	require('@Pui9Base/dist/pui9-base.css');
}

import './styles/app.css';

Vue.config.productionTip = false;

function defineGlobalPlugins() {
	Vue.use(Pui9Login);
	Vue.use(Pui9Menu);
	Vue.use(Pui9Notify);
	Vue.use(Pui9Datatables);
	Vue.use(Pui9Components);
	Vue.use(Pui9Base);
	Vue.use(Pui9Admin);

	Object.defineProperty(Vue.prototype, '$puiRequests', { value: Pui9HttpRequests });
	Object.defineProperty(Vue.prototype, '$puiEvents', { value: puiEventsBus });
	Object.defineProperty(Vue.prototype, '$puiI18n', { value: i18n });
}

function defineGlobalMixins() {
	Vue.mixin(Pui9LoginCheckerMixin(store, Pui9HttpRequests));

}

function setLanguage() {
	let lang = window.localStorage.getItem('pui9_lang') || store.state.global.defaultAppLang;
	i18n.locale = lang;
	vuetify.framework.lang.current = lang;
	vuetify.preset.lang.current = lang;
	vuetify.userPreset.lang.current = lang;
}

(async () => {
	puiEventsBus.$on('onPuiChangedLang', lang => {
		setLanguage();

		// reload default configurations and translate model columns if logged in
		const infoKey = store.state.session.keepSessionAliveInfoKey;
		const pui9_session = window.localStorage.getItem(infoKey);
		if (pui9_session) {
			store.dispatch('getInfoModels', {});
		}
	});

	Pui9HttpRequests.setStore(store);

	defineGlobalPlugins();
	setLanguage();

	await beforeRun();

	const vm = new Vue({
		vuetify,
		store,
		router,
		i18n,
		render: h => h(App)
	});
	
	defineGlobalMixins();

	store.$app = vm;

	vm.$mount('#app');
})();
